/* jshint node:true */
'use strict';

var browser = require('../helpers/utils/browser.js');
var appConfig = require('../../config');
var Path = require('../helpers/utils/path.js');
var moment = require('moment');
var config = {
    animationTimeout : 750, //ms,
    containerSelector : '#' + appConfig.uid,
    adPlaceholderSelector : '.react-ad'
};

function endLoadProgress(){
    setTimeout(function(){
        browser.call('espn_ui.Helpers.load_progress.stop');
    }, config.animationTimeout);
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Updates Page Meta Data
 * @param  {Object} meta
 */
function updateMetaData(meta){
	var title = meta.title;
	var description = meta.description;
	var keywords = meta.keywords;
	var root = meta.root;
	var label = meta.label;
    try{
    	jQuery("title").html(title);
        jQuery('meta[property="og:title"]').attr("content", title);
        jQuery('meta[name="twitter:title"]').attr("content", title);
        
    	jQuery('meta[name="description"]').attr("content", description);
        jQuery('meta[property="og:description"]').attr("content", description);
        jQuery('meta[name="twitter:description"]').attr("content", description);
        
    	jQuery('meta[name="keywords"]').attr("content", keywords);
    	if (root && label) {
    		jQuery('meta[name="root"]').attr("content", root);
    		jQuery('meta[name="label"]').attr("content", label);
    	} else {
    		jQuery('meta[name="root"]').attr("content", null);
    		jQuery('meta[name="label"]').attr("content", null);
    	}
    }catch(e){}
}

/**
 * Generates a Meta Data object
 * TODO: Use logic from Tea templates
 * @param  {String} sport  
 * @param  {String} page  
 * @param  {Object} meta
 * @return {Object}       
 */
function generateMetaData(sport, page, meta){
    
    meta = meta || {};
    
    var league = meta.leagueName || '';
	var metaHash = {
		scoreboard: {
			title : function(){
				return meta.title || ((league ? league + ' ': '') + 'Rugby Scores - ' + league + ' Scoreboard - ESPN');
			},
			description : function(){
				return meta.description || "Real-time " + league + " Rugby scores on ESPN.com.";
			}
		},
        match: {
            title : function(){
                var home = meta.home || '';
                var away = meta.away || '';
                var vs = ' vs ';
                var activeTab = '- ' + getSEOString(meta.activeTab);
                var league = '- ' + (meta.league || '');
                var date = ' - ' + (moment(meta.date).format("MMMM Do, YYYY") || '');
                var suffix = ' - ESPN UK';
				return [home, vs, away, activeTab, league + date + suffix].join(' ');
			},
			description : function(){
                var prefix = getSEODescriptonPrefix(meta.activeTab);
				return prefix + " " + (meta.home || '') + " vs " + (meta.away || '') + " " + (meta.league || '') + " rugby match.";
			}
        }
	};
    
    function getSEODescriptonPrefix(activeTab){
        var str = "Follow live coverage of the";
        switch (activeTab) {
            case 'commentary':
                str = 'Follow commentary of the';
            break;
            case 'matchstats':
                str = 'Get comprehensive statistics for the';
            break;
            case 'playerstats':
                str = 'Get player statistics for the';
            break;
            case 'lineups':
                str = 'Get Line-ups for the';
            break;
            case 'conversation':
                str = 'Join the conversation around the';
            break;
        }
        return str;
    }
    
    function getSEOString(str){
        str = str || 'Summary';
        
        switch (str) {
            case 'matchstats':
                str = 'Match Statistics';
            break;
            case 'playerstats':
                str = 'Player Statistics';
            break;
            case 'lineups':
                str = 'Line-up';
            break;
        }
        return capitalizeFirstLetter(str);
    }
    
    var matchTypes = {
        'match' : 'gamepackage',
        'summary' : 'gamepackage',
        'matchstats' : 'gamepackage',
        'playerstats' : 'gamepackage',
        'conversation' : 'gamepackage',
        'lineups' : 'gamepackage',
        'commentary' : 'gamepackage'
    };
    
    var type = matchTypes[page] || page;
    var pageType = matchTypes[page] ? 'match' : page;
    
	return {
		type : type,
		title : metaHash[pageType].title(),
		description : metaHash[pageType].description(),
		keywords : "ESPN, ESPNscrum, ESPN rugby, scrum, rugby, news, results, rugby world cup, rugby union, rugby, rugby rules, rugby history, rugby photos, rugby pictures, live rugby scores, rugby tickets"
	};
}

/**
 * Loops through all ad placeholders
 * having class `react-ad` and initializes them
 * @return {undefined}
 */
function initAds(){
    try{
        var ads = jQuery(config.adPlaceholderSelector);
        for(var i =0, len = ads.length; i < len; i++){
            admgr.initSlot(ads[i], espn.ads.config);
        }
    }catch(e){}
}

/**
 * Updates container classNames
 * @param  {Object} React component
 */
function updateClassNames(component){
    var classNames = {
        'ScoreboardHandler' : {
            add : [],
            remove : ['page-container']
        },
        Standings : {
            add : ['page-container'],
            remove : []
        },
        Home : {
            add : ['page-container'],
            remove : []
        },
        Gamecast : {
            add : [],
            remove : ['page-container']
        }
    };
    try{
        jQuery(config.containerSelector).addClass(classNames[component.constructor.displayName].add.join(' '))
            .removeClass(classNames[component.constructor.displayName].remove.join(' '));
    }catch(e){}
}

/**
 * Updates History state
 * @param  {Object} meta
 */
function updateHistoryState(meta, page){
    try {
        var content = {
            html : '<div class="main-content layout-bc"><div id="reactApp"></div></div>'
        };
        espn_ui.Helpers.history.updateState("url", location.href);
        espn_ui.Helpers.history.updateState("router", "react-router");
        espn_ui.Helpers.history.updateState("meta", meta);
        espn_ui.Helpers.history.updateState("content", content);
        if(page == 'scoreboard'){
            espn_ui.Helpers.history.updateState("customStyleSheet", 'scoreboards-rugby');
        }
    } catch (e) {}
}

/**
 * Updates Navigation based on sport and page
 * @param  {String} sport
 */
function updateNavigation(sport){
    try {
        jQuery('body').attr('data-sport', sport);
        espn_ui.Helpers.page.setContext(sport);
        jQuery(document).trigger('nav.sportChange');
    } catch (e) {}
}

/**
 * Callback to be called after route render
 */
function postRouteRender(){
    try{
        var pathname = this.context.router.getCurrentPathname();
        var request = Path.decode(pathname);
                
        if(request.page && request.sport){
            var page = request.page;
            var sport = request.sport;
            var meta;
            
            if(page === 'fixtures'){
                page = 'schedule'
            }else if(page === 'table'){
                page = 'standings'
            }
            
            meta  = generateMetaData(request.sport, page, this._meta);
            
            updateNavigation(sport);
            updateHistoryState(meta, page);
            updateMetaData(meta || history.state.meta);
        }
    }catch(e){}
}

module.exports = {
    componentDidMount: function() {
        updateClassNames(this);
        endLoadProgress();
    },
    componentDidUpdate: function(prevProps, prevState) {
        endLoadProgress();
    },
    componentWillMount: function() {
        postRouteRender.call(this);
    },
    componentWillUpdate: function() {
        // TODO: Reset ad container if it mutates
        postRouteRender.call(this);
    },
    _meta: {
        leagueName: '',
        description : '',
        title : ''
    }
};



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/mixins/ESPNhelpersMixin.js
 **/